module.exports = __webpack_public_path__ + "static/finb3-7c65ed86d2201480b9d34410fd59523f.jpg";